import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { isNullOrUndefined } from 'util';

@Injectable({
  providedIn: 'root'
})
export class GisSvgService {

  kaleshwaramUUID: any = 'dd4b923d-945d-47b3-aff3-de032d15f864';
  pumpHouseUUIDMap = {
    'Lakshmi PH': 'cf9b4453-6b75-40a1-a712-ea1bb26f2d7a',
    'Saraswati PH': '9c09411d-ab94-44b8-a398-8768f58c223e',
    'Parvathi PH': 'bafc976f-1ccc-4a91-aaa6-c3eac2470d36',
    'Nandi PH': '132307ae-f0ae-4944-963b-d52bbdce7100',
    'Gayathri PH': 'b4bdd6f9-552d-4f95-8569-25e66e9d98b4',
    'Annapurna PH': '4162f034-2b0a-44ca-bd10-a4f58d70236c',
    'Ranganayaka Sagar PH': '776913b4-d26f-4294-bf58-647ac401bae5',
    'Mallanna Sagar PH': '8d9a1edd-ec93-434b-85b7-79df3482a530',
    'Kondapochamma Sagar PH-1 Akkaram': '194f597b-03eb-4ab5-881d-6ea04dcd92e9',
    'Kondapochamma Sagar PH-2 Markook': 'ab34e4f8-46c8-4def-9476-12cb54d2efda',
    'Rampur PH': '17db13ed-9bab-45b0-ab3a-ba946097486a',
    'Rajeshwaraopet PH': '2c44a42e-4b64-4578-a961-44f86eee2939',
    'Mukpal PH': 'a795b5ff-fed6-4829-b126-6cfc221a7be2',
  };

  riverGaugeUUIDMap = {
    'Nasik FFS': '8b5c59ff-eee6-4558-b13f-cf2268db2e04',
    'Kopergaon FFS': '1722ae14-3109-4ab3-9692-4fb30f403e33',
    'Pachegaon FFS': '5fd5b355-eddf-4987-99cf-63d27bad8f8f',
    'Dhalegaon FFS': 'b3cca5ff-cb8a-440c-b01e-096f19f583e8',
    'G.R.BRIDGE FFS': '5d7ae990-e0f7-4244-b87a-8a223f0ac35f',
    'Zari FFS': '5ad6cc4e-af7f-44f1-b3e6-801a50b506ff',
    'Purna FFS': 'd6dd8b80-5b65-45ea-95fc-6b7745d362f2',
    'Gangakhed WL Station FFS': '1c27c719-2faf-4b9a-a21a-da9bf7ba39a1',
    'NANDED FFS': 'c40a9dad-1d55-4907-81f5-51a98a219b41',
    'Yelli FFS': 'b7af2e36-cc65-4bf6-9aa3-7cc45d11c46d',
    'Saigaon FFS': '758f07ca-a5d7-4d21-af49-ea7665e82a67',
    'DEGLOOR FFS': '83277aa8-30a7-4da2-997b-a51070fe1731',
    'Pothangal FFS': '91aed948-0b55-42a0-8a6f-46123cdc140e',
    'Saloora FFS': '44a2cf5b-f1d8-4ce9-835d-7fc8c3071837',
    'Jannepally FFS': 'c207d603-aa4e-49ae-9a93-aece472810b6',
    'Kalamadugu Bridge FFS': '42f123fd-a022-4672-a46f-217cf8a03426',
    'Mancherial FFS': '8886c5da-8d5a-481e-a867-b75c8ed272f5',
    'Indurthi Maneru FFS': '8a570ff8-cfaf-405f-b698-6e86187057f9',
    'Somanpally FFS': 'f7d4af03-5cae-4436-999b-870f4dc7fee0',
    'Kanhargaon FFS': '088453e8-667a-4b77-80dd-10a4c44f08fb',
    'Mangrul FFS': '6f8b9f7a-c052-46b1-a81e-a255b514d1fa',
    'Hivra FFS': '9e1d847f-db97-414c-be71-c91da6887896',
    'Nandgaon FFS': '9624a960-9e75-4de8-affd-f4fa3d50d021',
    'P.G. Bridge FFS': '325f936c-d7bb-4aa9-ad51-708204903ccb',
    'Bamni FFS': 'f8be765f-79d9-4586-9190-a685159f374c',
    'Venkatraopet (Wardha River) FFS': '0770f2cd-699b-4e56-beea-ea7a645456c8',
    'Sirpur FFS': 'a2224f9c-ecf9-413a-8643-83af8017e2aa',
    'Ramakona FFS': '69c19fe2-9901-4978-9c14-12eaec7cb6b3',
    'Satrapur (K.R.Bridge) FFS': '08bef0bd-a6e2-403f-8e04-62adbc2fdd2f',
    'Keolari FFS': 'e993e15f-912f-4ce8-aa88-7bbedb583423',
    'Kumhari FFS': 'fd5766ba-44f6-4001-89e4-7e9183d790bc',
    'Rajegaon FFS': '589eec9c-75bb-4dde-b439-11f91519d74e',
    'Chikhali FFS': '6781aaa3-9bea-4eb0-9e83-0e7aa3bd847d',
    'Bhandara FFS': '204023fd-8cf2-4eb9-8cfc-8137aea6d308',
    'Pauni FFS': '5f2b9644-668d-4aae-9085-9fc03789a9d1',
    'Salebardi FFS': 'e1f4c5bd-e717-45ca-8ccb-67b0be5531aa',
    'Wairagarh FFS': '21fb196b-1121-4da1-8ba4-681cb63a80c7',
    'Rajoli FFS': '151543c9-8eb7-42f1-937f-f3a5d749cd85',
    'Ashti FFS': '8c1843af-e61d-4c30-90d9-d12ab5a290ca',
    'Tummidihetti Barrage': '89c7a244-a018-11ea-bb37-0242ac130002',
    'Bhatpalli FFS': '48812080-80a4-4f6e-9f8e-7855c27216d4',
    'Gudem (Pranhita River Bridge) FFS': '83bf9963-4738-45ca-8b8d-1fcd86e39dab',
    'Nandigaon Peddavagu FFS': '740603ea-4ac1-4614-add0-2cd8752953fa',
    'Kyathanpally Peddavagu FFS': '4858c860-c747-49fa-a06e-1524b5deeb54',
    'Tekra FFS': '5b6324a3-1ad3-4ee3-b35a-9997e90f047f',
    'Katterasala FFS': '34479dd8-19e0-492c-b882-a1d8cc609281',
    'Chinnur FFS': 'f24a2380-3ca1-43d4-a421-0fe64bf272a4',
    'Kaleshwaram FFS': '8aaa06ce-9ebb-42fd-803c-737b8dacf0a8',
    'Nowrangpur FFS': '774636e6-bcfb-11ea-a7ae-b46bfcc5bc3c',
    'Jagdalpur FFS': '6831d9ae-bcfb-11ea-a7ae-b46bfcc5bc3c',
    'Pathagudem FFS': '2b7fef26-14d8-40c1-8b77-fcb1a2b304ef',
    'Perur FFS': '56dbd983-835f-412c-af68-018379aa9a57',
    'Bhadrachalam FFS': '34b85ec2-869f-11e8-adc0-fa7ae01bbebc',
    'Konta FFS': '02e3ad92-86a0-11e8-adc0-fa7ae01bbebc',
    Kunavaram_FFS: 'f99e4c5a-0e00-46af-866d-719466c277fa',
    'Koida FFS': '3fbfc4e2-4e74-4dc4-a50f-1dc8256e0b9c',
    Tallapudi_RR_FFS: 'dd92b883-8252-4a42-aa9c-582db4936b47',
    'Ghugus FFS': '1be8af92-ce8f-47a0-a4bc-69e676029b45',
    'Mirdapalli FFS': 'faefc210-38ea-4d5e-91ca-9a7531ec04b7',
    'Ambabal FFS': '31776a37-5ce6-4c51-8c82-dac42b3ab366',
    'Ankushapur FFS': 'fe468687-eda8-44d8-b2f7-a0a17be42d93',
    'Betmogra FFS': 'b938ad4b-7068-48b7-849f-9d172047e2bd',
    'Cherribeda FFS': '3f1440bd-36ed-4f14-b56e-6265d9cc8a04',
    'Chindnar FFS': '506e0157-81de-4f4b-9fee-62d2888c8c6f',
    'Gandlapet FFS': '97d787de-052c-4ad5-8017-2770bb72c09b',
    'Garmillapalli FFS': '4bc1de0f-8df5-49b7-95cc-29725a884a96',
    'Kerlapal FFS': 'e0cdaa47-232d-4dfa-aeb1-ac447a29ce58',
    'Kiwaibalenga FFS': 'f67736e8-5ed9-4c5c-87f8-2229ce2b43bc',
    'Kosagumda FFS': 'a210cd15-ed88-4814-a8c7-911d5136fce1',
    'Kunturla FFS': '3f812d64-4356-4a96-9832-fc6d0147be1d',
    'Murthahandi FFS': 'd8bb6150-1e94-43a6-a4d5-62c7baabda0e',
    'Potteru FFS': 'a180e6ef-00ee-4d31-a5a2-5776d00c77a1',
    'Pratapur FFS': '6d1cb504-9b0b-41ae-b464-bd1b578ea4a2',
    'Sangam FFS': 'ae27d023-ee38-4308-8ff0-007127a0dda7',
    'Sangampally FFS': '78189f38-c98b-457e-b771-1e3b9f04e8e7',
    'Saradaput FFS': '4770bb77-5727-4861-bc9d-c598a46f2d43',
    'Sonarpal FFS': '2cee478c-e9c2-4815-9b8d-5a2c63a77737',
    'Tumnar FFS': 'b57f0955-c5d9-4369-b591-d18cd1ce5ac2',
    'Valamuru FFS': '39f90f6d-f7b0-49bb-a6d7-6d8a6a107f1d',
    'Allamvari Ghanpur FFS': '404f4ca1-9b26-4e8c-be69-961d5f437384',
    'Talnar FFS': '7ab23c46-b559-43f1-890b-b1f872e201db',
    'Janwada FFS': 'f88fab1a-504e-4da1-9cf4-ce59627bb079',
    'Pochavaram FFS': '39ea7da0-2a5e-4fc6-8157-045085af16c0',
    'Kupthi Bridge - Kaddam': '2b01eb7d-bcfb-11ea-a7ae-b46bfcc5bc3c',
    'Peddavagu Penchikalpet': '4082d8ca-bcfb-11ea-a7ae-b46bfcc5bc3c',
    'Pranahitha Mukkigudem': '46db5364-bcfb-11ea-a7ae-b46bfcc5bc3c',
    'Mulakatta Bridge': '5cd93bbe-bcfb-11ea-a7ae-b46bfcc5bc3c'
  };

  reservoirUUIDMap = {
    'Annapurna Reservoir': 'd10f7b05-437c-4d9a-a6c4-2518e2af146f',
    'Nrusimha Sagar Reservoir': '3a6f925f-41f4-44dd-bf49-a03206aef14d',
    'Bhumpally Reservoir': '2b352a77-8835-4580-bb66-0ac26a138297',
    'Channakha - Korata Barrage': '1d5bd3be-c66a-11ea-87d0-0242ac130003',
    'Gandamalla Reservoir': 'c262143a-40b3-4d81-82f4-54af3d5c3a2c',
    'JAIKWADI': 'cc7d3ffc-7560-11e8-adc0-fa7ae01bbebc',
    'Kaddam Adi Narayana Reddy Project': 'd3d6c7f6-4657-4db1-9cdc-5916e303aafc',
    'Komaravelly Mallanna Sagar': 'a7466c95-06f2-4758-ad6e-2e2f22aa1e32',
    'Konda Pochamma Reservoir': '48b8ed68-c12c-48e4-9786-5ad1f840b1f2',
    'Kondem Cheruvu': '5b3da942-039c-44ce-ac55-1cb5e38fd39d',
    'Lakshmi Barrage': 'c349a4e3-c46c-4f16-b538-6bd232956dd8',
    'Lower Manair Dam': '0158fd37-38f0-4c98-bc48-041ed91e1faf',
    'Malakpet Reservoir': '8af0af48-ed98-4b29-83ef-756d73aee061',
    'Masani Tank (Nyakal)': '49aa62b4-68fb-42fb-8e8f-f56889d95cc1',
    'Mogaligundla Baga Reddy Singur Project': 'ef9351ed-9cf3-427d-80c0-c577b155018e',
    'N.M. Weir': 'fe62e2a5-f901-4b20-998c-77b512c14f9f',
    'Nandi Reservoir': 'ab822f73-99d7-496e-bdfc-8e7fa0379a61',
    'Nizam Sagar Project': '45321840-5bc0-4b6e-95f2-94b6b30c2f1d',
    'Parvathi Barrage': '23425b07-d6bc-4c9f-914d-184598b719ae',
    'Polavaram Project': 'e08f26be-7564-11e8-adc0-fa7ae01bbebc',
    'Sadarmat Barrage': 'cd81b541-4325-4456-8429-fe09eab21557',
    'Saraswati Barrage': 'a9941f72-00c7-4dd7-b5e6-6c591be8aab9',
    'Shameerpet Lake': '95746cb9-477f-4c50-a182-95952f9df159',
    'Sir Aurthur Cotton Barrage': '06d4797e-33e0-499f-b6b4-f34f8ffc1191',
    'Sri Pada Yellampalli Project': '5459d9e6-7564-11e8-adc0-fa7ae01bbebc',
    'Sri Ram Sagar Project': '86d88206-7563-11e8-adc0-fa7ae01bbebc',
    'Sri Ranganayaka Sagar': '50e8fe61-c76f-44b5-a2b0-ac2a0c7d70ce',
    'SRR Reservoir': '1efe0cb7-b25c-4935-9ff2-a08a81fef0e2',
    'Taliperu Dam': '29a08448-7b62-497d-aec0-55f31842f87d',
    'Tummidihetti Barrage': '89c7a244-a018-11ea-bb37-0242ac130002',
    'Upper Manair Dam': 'a3130bc9-c68f-4bd6-b6ca-8a3db115081f',
    'Bayyanavagu balancing Reservoir': '6724dc0e-fce1-11ea-adc1-0242ac120002',
    'Dindi Project': '4febe640-0825-48ed-9a13-b94b75134ecd',
    'Jurala': 'f4f4a30e-00f5-4249-a313-d9779496f49b',
    'Kinnerasani': 'd236fa7d-88c9-42e4-b1b8-76a90fb18dd9',
    'Mylaram Balancing Reservoir': '777c0410-fce1-11ea-adc1-0242ac120002',
    'Nagarjuna Sagar': 'cdad2a5e-91ab-11e5-8994-feff819cdc9f',
    'Srisailam R': 'cdad2e1e-91ab-11e5-8994-feff819cdc9f',
    'Somasila Reservoir': '0f512470-1770-11e6-b6ba-3e1d05defe78',
    'Peddavagu (NEELWAI)': 'e2b1dd90-66fa-436b-bc3d-90874404c511',
    'Pocharam Project': 'fa07d52e-a54b-4816-a4d5-7a816fca745b',
    'Musurimalli': 'bc715334-4dab-11e6-a0d5-68f72823d03e',
    'PP Rao Project (YERRA Vagu)': '5100714e-4f02-4204-9da2-5898a547fb85',
    'Pulichinthala Project': '52f0e841-9f3f-4f08-9e2e-80782055ddcf',
    'Sunkesula Barrage': '2c01a0fd-388d-4d3c-b790-726f8ca0d690',
    'Apegaon H.L.Barrage': '19131942-0df1-11eb-adc1-0242ac120002',
    'Babhali H.L.Barrage': '993ca1b0-266e-4b3d-9045-cadb1ad99cb6',
    'Balegaon H.L.Barrage': '43ecc276-0df1-11eb-adc1-0242ac120002',
    'Bhategaon': '4eaeec0c-0df1-11eb-adc1-0242ac120002',
    'Chichdoh Barrage': '0b8e2fd8-b9ac-4d84-b84d-f251620e33f6',
    'Chinchoti': '641e0c58-0df1-11eb-adc1-0242ac120002',
    'Dhalegaon H.L.Barrage': '6f35b348-0df1-11eb-adc1-0242ac120002',
    'Digras H.L.Barrage': '7a6442c0-0df1-11eb-adc1-0242ac120002',
    'Gosikhurd National Project': 'ef172744-ea21-48f3-86e7-97d40aedf5be',
    'Hiradpuri H.L.Barrage': '934679de-0df1-11eb-adc1-0242ac120002',
    'Jogladevi H.L.Barrage': 'a0c6d982-0df1-11eb-adc1-0242ac120002',
    'Loni Sawangi H.L.Barrage': 'ab007c96-0df1-11eb-adc1-0242ac120002',
    'Mangrul H.L.Barrage': 'b625bb04-0df1-11eb-adc1-0242ac120002',
    'Mudgal H.L.Barrage': 'c16e573c-0df1-11eb-adc1-0242ac120002',
    'Muli H.L.Barrage': 'c926667c-0df1-11eb-adc1-0242ac120002',
    'Pimpalwadi (Jalna)': 'd0cc506c-0df1-11eb-adc1-0242ac120002',
    'Raja Takali H.L.Barrage': 'dde43fe4-0df1-11eb-adc1-0242ac120002',
    'Sonpethwadi': 'e59a2da2-0df1-11eb-adc1-0242ac120002',
    'Vishnupuri': 'f27408cc-0df1-11eb-adc1-0242ac120002',
    'Thupakulagudem Barrage': '5c787016-e53c-11ea-bd79-d3fa4f4c8f6c',
    'Dharmaraopet Tank': '80b7a688-f679-11ea-adc1-0242ac120002',
    'Katewadi Reservoir': 'a1733cb6-f679-11ea-adc1-0242ac120002',
    'Mothe Reservoir': 'ac3088f2-f679-11ea-adc1-0242ac120002',
    'Muddojiwadi Tank': '913e22fc-f679-11ea-adc1-0242ac120002',
    'SRISAILAM R': "cdad2e1e-91ab-11e5-8994-feff819cdc9f",
    'SUNKESULA BARRAGE': "2c01a0fd-388d-4d3c-b790-726f8ca0d690",
    'PULICHINTHALA PROJECT': "52f0e841-9f3f-4f08-9e2e-80782055ddcf",
    'KURUNDWAD': "5a1b6d48-294e-4718-b186-562f4f922e0c",
    'PRAKASAM BARRAGE': "13c7d756-b5a5-4938-bc90-f380c1bdf324",
    'UJJAINI':"70d65cf9-31d7-4c1a-9a3e-77ed8899bff9",
    'ALMATTI': "4f4a6fdd-5af3-4871-b898-e6031837b9ed",
    'JURALA': "f4f4a30e-00f5-4249-a313-d9779496f49b",
    // 'NAGARJUNA SAGAR': "cdad2a5e-91ab-11e5-8994-feff819cdc9f",
    'NARAYANAPUR': "b6947dc8-4e18-443b-9c6e-05e0d1de67a5",
    'Sittama Barrage': '28cd84da-d9b1-11eb-b8bc-0242ac130003',
    'VARATTAR VALLIMA': '62c394f2-3e0b-4a6d-abc4-13019a892609',
    'SATHANUR':'91796ea1-f895-4aba-89f6-b250a881f244',
    'VAANIAR':'688d6803-9422-40fc-b262-6cce95b172e0',
    'PAMBAR':'25b70227-f4a3-4843-b341-eed2a6c10541',
    'ANDIAPPANUR ODAI':'03ca541b-74ea-4595-a07d-8eaff72bdf2f',
    'THUMBALAHALLI':'f80b546a-a535-46ec-ba35-cb56ffba3620',
    'KRISHNAGIRI':'858b48e3-2edc-4a09-a2fe-04abea2f221f',
    'SULAGIRICHINNAR':'036fad2b-7b8a-49cb-9e28-ab418c54bf68',
    'KELAVARAPALLI':'7ac02c32-6c96-42c8-9086-84872b3668df',
    'Erattayar Dam':'69078de4-fdd4-44dc-b096-dac992deddbf',
    'Kallar Dam':'b069c1e1-2e71-4952-86de-9023773a6143',
    'Ponmudi Dam':'99771002-020f-4706-b205-48cb5b804677',
    'Kallarkutty Dam':'e7f90e80-49a7-41f3-9024-937c6b483abf',
    'Pambla Dam(Lower Periyar)':'7deb4415-594b-41c4-bf4a-22bfc9ae1e4f',
    'Anayirankal Dam':'7922950e-5d37-4f41-8bc1-4e0ed53cb422',
    'Mattupetty Dam':'ad789e14-3619-4aed-8e24-ec0784922da6',
    'Kundala Dam':'371c0b4d-7b28-4ed1-9715-7abf4da2b594',
    'Sholayar Dam':'77ac2530-189c-4cef-b927-9e23f12b38b7',
    'Parambikulam Dam':'aad5b1c5-2aee-41dd-b0e0-c1dcbc7d2dc7',
    'Peringalkuthu Dam':'5b74a942-c824-46ec-8377-a7f7471918a3',
    'GOTTA BARRAGE':'129ef2e7-05f7-409f-bfca-2dda47669060',
    'Ghodahada':'69951b29-3643-48a2-8e23-ed791aa63cab',
    'Soroda':'31d1d415-ac6a-4dc5-8ca4-8cbd508ebbcd',
    'Dhanei':'e9147cc5-87eb-4d24-ae6c-01c6e502769b',
    'Bhanjanagar':'cd69d853-c9ca-4d7f-81f4-09b06cb21f2c',
    'Daha':'9ff9435f-e0cf-4530-8be6-a6387e2fa83f',
    'Derjang':'2de33a9f-6b4b-4593-bc4a-86599638b785',
    'Ramial':'fe28edc5-645d-48a3-8405-653476adfb3e',
    'Remal':'c60f4722-804d-44b5-ba75-e642f1b4a1fa',
    'Salandi':'17c7f345-095f-4ddd-8d08-d9e168f4560b',
    'Rengali':'7067df8a-b354-4555-a985-b0d7fecb6e97',
    'Kanjhari':'b8004cb1-0e94-45fa-80a8-7e440d3fec71',
    'Pitamahal':'5989e1e9-f52c-42f5-860b-aabc7fbf030c',
    'Kansabahal':'c5be07fb-b92f-428c-b8f2-cadc7c1d72cb',
    'Hasdeo Barrage':'1184e643-29d7-46bb-a857-0af4e8ff3431',
    'Gohira':'86e9fb52-be15-4c15-8603-68eabf3c3440'






  };

  constructor() { }

  getWaterSourceNameFromUUID(waterSourceUUID, type) {
    if (type == 'RESERVOIR' ||type == 'OS_RESERVOIR') {
      for (const key in this.reservoirUUIDMap) {
        // console.log(key);
        if (!isNullOrUndefined(key)) {
          const resUUID = this.reservoirUUIDMap[key];
          if (resUUID == waterSourceUUID) {
            return key;
          }
        }
      }
      return null;
    } else if (type == 'PUMP_HOUSE') {
      for (const key in this.pumpHouseUUIDMap) {
        if (!isNullOrUndefined(key)) {
          const pHUUID = this.pumpHouseUUIDMap[key];
          if (pHUUID == waterSourceUUID) {
            return key;
          }
        }
      }
      return null;
    } else {
      for (const key in this.riverGaugeUUIDMap) {
        if(!isNullOrUndefined(key)) {
          const riverGaugeUUID = this.riverGaugeUUIDMap[key];
          if (riverGaugeUUID == waterSourceUUID) {
            return key;
          }
        }
      }
      return null;
    }
  }

  getstartandEndForNday(nday) {
    let startDate;
    let endDate;
    const startandEndList = [];
    const currentDate = new Date();
    const currentTs = new Date().setHours(0, 0, 0, 0);
    const rfStartofDay = currentTs + 8.5 * 3600 * 1000;
    if (currentDate.getTime() >= rfStartofDay) {
      endDate = moment().format('YYYYMMDD');
      startDate = moment().subtract(nday - 1, 'days').format('YYYYMMDD');
    } else {
      endDate = moment().subtract(1, 'days').format('YYYYMMDD');
      startDate = moment().subtract(nday, 'days').format('YYYYMMDD');
    }
    startandEndList[0] = startDate;
    startandEndList[1] = endDate;
    return startandEndList;
  }

  getMonsoonYearFromModelDate() {
    let modelDate = moment().format('YYYYMMDD');
    modelDate = modelDate.toString();
    const year = modelDate.substring(0, 4);
    const month = modelDate.substring(4, 6);
    if (parseInt(month, 10) > 5) {
      return parseInt(year, 10);
    } else {
      return parseInt(year, 10) - 1;
    }
  }

  getPostDataForAllPumpHousePopup() {
    const monsoonYear = this.getMonsoonYearFromModelDate();
    const postData = {
      pEUUID: 'dd4b923d-945d-47b3-aff3-de032d15f864',
      pUUID: 'dd4b923d-945d-47b3-aff3-de032d15f864',
      pType: 'IRRIGATION_SYSTEM',
      cType: 'PUMP_HOUSE',
      format: 'YEARLY',
      sDate: monsoonYear,
      eDate: monsoonYear,
      src: 'TELANGANA_IRRIGATION_DEPARTMENT',
      classification: ['INSTANT_DATA'],
      aggr: 'LATEST'
    };
    return postData;
  }

  getPostDataForIndividualPumpHousePopup(pUUID) {
    const monsoonYear = this.getMonsoonYearFromModelDate();
    const postData = {
      pEUUID: 'dd4b923d-945d-47b3-aff3-de032d15f864',
      pUUID,
      pType: 'PUMP_HOUSE',
      cType: 'NONE',
      format: 'YEARLY',
      sDate: monsoonYear,
      eDate: monsoonYear,
      src: 'TELANGANA_IRRIGATION_DEPARTMENT',
      classification: ['INSTANT_DATA'],
      aggr: 'LATEST'
    };
    return postData;
  }

  getPostDataForAggregatedIndividualPumpHouse(pUUID, type) {
    const monsoonYear = this.getMonsoonYearFromModelDate();
    let postData;
    if (type == 'yearly') {
      postData = {
        pEUUID: 'dd4b923d-945d-47b3-aff3-de032d15f864',
        pUUID,
        pType: 'PUMP_HOUSE',
        cType: 'NONE',
        format: 'YEARLY',
        sDate: monsoonYear,
        eDate: monsoonYear,
        src: 'TELANGANA_IRRIGATION_DEPARTMENT',
        classification: ['AGGREGATED_DATA'],
        aggr: 'SUM'
      };
    } else if (type == 'daily') {
      const startDate = moment().format('YYYYMMDD');
      const endDate = moment().format('YYYYMMDD');
      postData = {
        pEUUID: 'dd4b923d-945d-47b3-aff3-de032d15f864',
        pUUID,
        pType: 'PUMP_HOUSE',
        cType: 'NONE',
        format: 'DAILY',
        sDate: startDate,
        eDate: endDate,
        src: 'TELANGANA_IRRIGATION_DEPARTMENT',
        classification: ['AGGREGATED_DATA'],
        aggr: 'SUM'
      };
    }
    return postData;
  }

  getPostDataForIndividualPumpHouseChart(pUUID, startTs, endTs) {
    const postData = {
      pEUUID: 'dd4b923d-945d-47b3-aff3-de032d15f864',
      pUUID,
      pType: 'PUMP_HOUSE',
      cType: 'NONE',
      format: 'HOURLY',
      src: 'TELANGANA_IRRIGATION_DEPARTMENT',
      sDate: startTs,
      eDate: endTs,
      classification: ['INSTANT_DATA']
    };
    return postData;
  }

  getPostDataForAllRiverGaugePopup() {
    const monsoonYear = this.getMonsoonYearFromModelDate();

    const postData = {
      pEUUID: '9553a7af-56f8-495f-ba0c-c2d2324e6759',
      pUUID: '9553a7af-56f8-495f-ba0c-c2d2324e6759',
      pType: 'COUNTRY',
      cType: 'RIVER_GAUGE',
      format: 'YEARLY',
      src: 'STATE_AND_CENTRAL_STATIONS',
      sDate: monsoonYear,
      eDate: monsoonYear,
      classification: ['INSTANT_DATA'],
      aggr: 'LATEST'
    };
    return postData;
  }


  getPostDataForIndividualRiverGauge(riverGaugeUUID) {
    const monsoonYear = this.getMonsoonYearFromModelDate();

    const postData = {
      pEUUID: '9553a7af-56f8-495f-ba0c-c2d2324e6759',
      pUUID: riverGaugeUUID,
      pType: 'RIVER_GAUGE',
      cType: 'NONE',
      format: 'YEARLY',
      src: 'STATE_AND_CENTRAL_STATIONS',
      sDate: monsoonYear,
      eDate: monsoonYear,
      classification: ['INSTANT_DATA'],
      aggr: 'LATEST'
    };
    return postData;
  }


  getLast3DayReservoirPostData() {
    const monsoonYear = this.getMonsoonYearFromModelDate();

    const postData = {
      pEUUID: '9553a7af-56f8-495f-ba0c-c2d2324e6759',
      pUUID: '9553a7af-56f8-495f-ba0c-c2d2324e6759',
      pType: 'COUNTRY',
      cType: 'RESERVOIR',
      src: 'STATE_AND_CENTRAL_STATIONS',
      format: 'YEARLY',
      sDate: monsoonYear,
      eDate: monsoonYear,
      classification: ['INSTANT_DATA'],
      aggr: 'LATEST'
    };
    return postData;
  }

  getLast3DayIndividualReservoirPostData(reservoirUUID) {
    const monsoonYear = this.getMonsoonYearFromModelDate();

    const postData = {
      pEUUID: '9553a7af-56f8-495f-ba0c-c2d2324e6759',
      pUUID: reservoirUUID,
      pType: 'RESERVOIR',
      cType: 'RESERVOIR',
      src: 'STATE_AND_CENTRAL_STATIONS',
      format: 'YEARLY',
      sDate: monsoonYear,
      eDate: monsoonYear,
      classification: ['INSTANT_DATA'],
      aggr: 'LATEST'
    };
    return postData;
  }

  getTransitLandingTabData(systemUUID, pType) {
    const monsoonYear = this.getMonsoonYearFromModelDate();

    const postData = {
      pEUUID: '9553a7af-56f8-495f-ba0c-c2d2324e6759',
      pUUID: systemUUID,
      pType,
      cType: 'NONE',
      src: 'STATE_AND_CENTRAL_STATIONS',
      format: 'YEARLY',
      sDate: monsoonYear,
      eDate: monsoonYear,
      classification: ['AGGREGATED_DATA'],
      aggr: 'LATEST',
      resType: 'TRANSIT_RESERVOIR'
    };
    return postData;

  }

  getNonTransitLandingTabData(systemUUID, pType) {
    const monsoonYear = this.getMonsoonYearFromModelDate();

    const postData = {
      pEUUID: '9553a7af-56f8-495f-ba0c-c2d2324e6759',
      pUUID: systemUUID,
      pType,
      cType: 'NONE',
      src: 'STATE_AND_CENTRAL_STATIONS',
      format: 'YEARLY',
      sDate: monsoonYear,
      eDate: monsoonYear,
      classification: ['AGGREGATED_DATA'],
      aggr: 'LATEST',
      resType: 'NON_TRANSIT_RESERVOIR'
    };
    return postData;
  }

  getSystemLevelLandingPumpTabData(systemUUID, pType, type) {
    let postData;
    const monsoonYear = this.getMonsoonYearFromModelDate();
    const startEndList = this.getstartandEndForNday(1);
    const startDate = startEndList[0];
    const endDate = startEndList[1];
    if (type == 'yearly') {
      postData = {
        pEUUID: 'dd4b923d-945d-47b3-aff3-de032d15f864',
        pUUID: systemUUID,
        pType,
        cType: 'NONE',
        format: 'YEARLY',
        sDate: monsoonYear,
        eDate: monsoonYear,
        src: 'TELANGANA_IRRIGATION_DEPARTMENT',
        classification: ['AGGREGATED_DATA'],
        aggr: 'SUM'
      };
      return postData;
    } else if (type == 'daily') {
      postData = {
        pEUUID: 'dd4b923d-945d-47b3-aff3-de032d15f864',
        pUUID: systemUUID,
        pType,
        cType: 'NONE',
        format: 'DAILY',
        sDate: startDate,
        eDate: endDate,
        src: 'TELANGANA_IRRIGATION_DEPARTMENT',
        classification: ['AGGREGATED_DATA'],
        aggr: 'SUM'
      };
      return postData;
    }
  }

  getKaleshwaramChartPostData(systemUUID, pType, startTs, endTs) {
    const postData = {
      pEUUID: '9553a7af-56f8-495f-ba0c-c2d2324e6759',
      pUUID: systemUUID,
      pType,
      cType: 'NONE',
      src: 'STATE_AND_CENTRAL_STATIONS',
      format: 'HOURLY',
      sDate: startTs,
      eDate: endTs,
      classification: ['AGGREGATED_DATA'],
      aggr: 'LATEST',
      resType: 'ALL'
    };
    return postData;
  }


  getPostDataForAllSystemMeta() {
    const postData = {
      pEUUID: '9553a7af-56f8-495f-ba0c-c2d2324e6759',
      pUUID: 'dd4b923d-945d-47b3-aff3-de032d15f864',
      pType: 'IRRIGATION_SYSTEM',
      cType: 'SUB_IRRIGATION_SYSTEM',
      src: 'STATE_AND_CENTRAL_STATIONS',
      format: 'YEARLY',
      sDate: '2020',
      eDate: '2020',
      classification: ['AGGREGATED_DATA'],
      aggr: 'LATEST',
      resType: 'ALL'
    };
    return postData;
  }

  getPumpWaterLiftedMetaDataForAllSystem() {
    const postData = {
      pEUUID: 'dd4b923d-945d-47b3-aff3-de032d15f864',
      pUUID: 'dd4b923d-945d-47b3-aff3-de032d15f864',
      pType: 'IRRIGATION_SYSTEM',
      cType: 'SUB_IRRIGATION_SYSTEM',
      src: 'TELANGANA_IRRIGATION_DEPARTMENT',
      format: 'YEARLY',
      sDate: '2020',
      eDate: '2020',
      classification: ['AGGREGATED_DATA'],
      aggr: 'SUM'
    };
    return postData;
  }

  getPostDataForReservoirList(systemUUID, pType, cType, restype) {
    const monsoonYear = this.getMonsoonYearFromModelDate();
    const postData = {
      pEUUID: '9553a7af-56f8-495f-ba0c-c2d2324e6759',
      pUUID: systemUUID,
      pType,
      cType,
      src: 'STATE_AND_CENTRAL_STATIONS',
      format: 'YEARLY',
      sDate: monsoonYear,
      eDate: monsoonYear,
      classification: ['AGGREGATED_DATA'],
      aggr: 'LATEST',
      resType: restype

    };
    return postData;
  }

}
